import { makeStyles } from 'makeStyles';

const CONTAINER_WIDTH = 560;

export const useStyles = makeStyles()((theme) => ({
  tmxDialog: {},
  tmxDialogPaper: {
    width: '100%',
    maxWidth: CONTAINER_WIDTH,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(4),
  },
  selectDrawFormContent: {
    margin: `${theme.spacing(4)} 0`,
  },
  drawCheckbox: {
    alignItems: 'flex-start',
  },
  drawCheckboxRoot: {
    paddingTop: 0,
  },
  drawCheckboxLabelDisabled: {
    color: theme.palette.grey[50],
  },
}));
